import { ReactElement, useCallback } from 'react';

import { DocplannerDoctorAddressMapping, DocplannerPractitioner } from '@dreryk/egabinet-docplanner-frontend-api';

import { useBoolean } from '@dreryk/react-common';
import { EditIcon, IconWrapper } from '@dreryk/react-components';

import { AddDoctorAssociationModal } from './AddDoctorAssociation/AddDoctorAssociationModal';

type EditDoctorMappingProps = {
   readonly docplannerDoctorId: string;
   readonly docplannerDoctorFirstName: string;
   readonly docplannerDoctorLastName: string;
   readonly doctorAddressMappings: DocplannerDoctorAddressMapping[];
   readonly associatedPractitioner: DocplannerPractitioner | undefined;
   readonly onAssociationSetSuccess: VoidFunction;
};

export const EditDoctorMapping = (props: EditDoctorMappingProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const handleAssociationSetSuccess = useCallback(() => {
      props.onAssociationSetSuccess();
      closeModal();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeModal, props.onAssociationSetSuccess]);

   return (
      <>
         <IconWrapper testId={'editDoctorAssociation'} onClick={openModal}>
            <EditIcon />
         </IconWrapper>
         {modalOpened ? (
            <AddDoctorAssociationModal
               docplannerDoctorId={props.docplannerDoctorId}
               docplannerDoctorFirstName={props.docplannerDoctorFirstName}
               docplannerDoctorLastName={props.docplannerDoctorLastName}
               associatedPractitioner={props.associatedPractitioner}
               doctorAddressMappings={props.doctorAddressMappings}
               onClose={closeModal}
               onAssociationSetSuccess={handleAssociationSetSuccess}
            />
         ) : null}
      </>
   );
};
